
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ScrollTracking label='content75' mdxType="ScrollTracking" />
    <h4>Nun also doch die Verwahrung</h4>
    <p>
  Die erneute Verhaftung von William W. wird publik. Nur von einem Fall ist anfangs die Rede. Doch innert Tagen melden
  sich die weiteren mutmasslichen Opfer der geschilderten Fälle. Der Beschuldigte bestreitet in Untersuchungshaft alle
  Vorwürfe.
    </p>
    <p>
  Nun beantragt das Solothurner Innendepartement seine Verwahrung. William W. sei «ein Wiederholungstäter», er habe
  «sexuelle Handlungen mit Kindern in verschiedenen Kontexten vorgenommen». Die Behörden schreiben, was offensichtlich
  ist: Mit dem Vollzug in Freiheit könne man die nötige Überwachung und Kontrolle nicht gewährleisten. Deshalb müsse man
  diesen «wegen Aussichtslosigkeit» aufheben.
    </p>
    <p>
  Der Solothurner Justizdirektor Roland Fürst (CVP) kündigt an, er wolle den Fall nun aufrollen. Eine externe
  Untersuchung soll Klarheit schaffen, ob jemand Fehler gemacht hat. In der SonntagsZeitung meldet sich auch Selina zu
  Wort, mittlerweile 20 Jahre alt: «Ich habe immer geahnt, dass er wieder zuschlägt.» Sie sei enttäuscht von den
  Justizbehörden. «Gutachter haben noch davor gewarnt, dass bei ihm ein Rückfallrisiko besteht.» Das neueste
  mutmassliche Opfer soll acht Jahre alt gewesen sein. So wie sie damals in der Baubaracke.
    </p>
    <Image source='Die SonntagsZeitung berichtet über den mutmasslichen Rückfall. (RD)' file={require('images/sz_rueckfall.png')} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;